import InternationalSolutionsPage from "./InternationalSolutionsPage";

const INTERNATIONAL_SOLUTIONS_PATH = "/international-solutions";

export { InternationalSolutionsPage, INTERNATIONAL_SOLUTIONS_PATH };
